import React, { useEffect, useState } from 'react';
import { MonitorSmartphone, Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import { useApp } from '../../context/AppContext';
import { Panel } from '../../components/common';
import { relTime } from '../../lib/compliance';

export function KnownDevicesPanel() {
  const app = useApp();
  const [devices, setDevices] = useState(null);
  const load = () => app.getDevices().then(setDevices);
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const mine = localStorage.getItem('kyc_device');
  const forget = async (d) => { if (await app.forgetDevice(d.id)) { toast.success('Browser forgotten — the next sign-in from it will trigger a new-sign-in alert'); load(); } };
  return (
    <Panel title={<span className="flex items-center gap-2"><MonitorSmartphone className="h-4 w-4 text-ink-400" />Known browsers</span>} description="Signing in from a browser not on this list sends you a new-sign-in alert (email + in-app, per your preferences above) so account takeovers get noticed fast.">
      {!devices ? <div className="text-xs text-ink-400">Loading…</div> : !devices.length ? <div className="text-sm text-ink-400" data-testid="devices-empty">No browsers recorded yet.</div> : (
        <ul className="divide-y divide-line text-sm" data-testid="devices-list">
          {devices.map((d) => <li key={d.id} data-testid={`device-${d.id === mine ? 'current' : 'other'}`} className="flex items-center gap-3 py-2">
            <div className="flex-1 min-w-0"><div className="font-medium text-ink-800">{d.browser} on {d.os}{d.id === mine && <span className="ml-2 rounded-md border border-emerald-200 bg-emerald-50 px-1.5 py-0.5 text-[10px] font-semibold text-emerald-700">this browser</span>}</div><div className="text-xs text-ink-400">{d.location && <span data-testid="device-location" className="text-ink-600">{d.location} · </span>}IP {d.ip} · first seen {relTime(d.firstSeen)} · last {relTime(d.lastSeen)}</div></div>
            <button data-testid="device-forget" onClick={() => forget(d)} className="text-ink-400 hover:text-rose-600 transition-colors" title="Forget this browser"><Trash2 className="h-4 w-4" /></button>
          </li>)}
        </ul>
      )}
    </Panel>
  );
}
